import { BaseModel } from './baseModel';

export class OfflineModel {
    Id;
    SiteId;
    Name;
    OfflineData;
    Cache;

    constructor(Id, SiteId, Name, OfflineData, Cache) {
        this.Id = Id === null ? Date.now() : Id;
        this.SiteId = SiteId === null ? null : SiteId;
        this.Name = Name === null ? null : Name;
        this.OfflineData = OfflineData === null ? null : OfflineData;
        this.Cache = Cache === null ? true : Cache;
    }
}

export class OfflineExtend extends BaseModel {

    constructor() {
        super(['OfflineData']);

    }

    fillToProp = (obj, prop) => {
        prop.Id = obj.Id;
        prop.SiteId = obj.SiteId;
        prop.Name = obj.Name;
        prop.OfflineData = obj.OfflineData;
        prop.Cache = obj.Cache;
    };
}
